export const maxBigInt = (a: bigint, b: bigint) => (a > b ? a : b)

export const absBigInt = (v: bigint) => (v >= 0n ? v : -v)
